import type { Locale } from '../../store/locale'

/** The language the Profile picker starts on: the saved account language, else
 * the language the UI is actually in — never a blind 'en', which saving any
 * other field would then write back over a Turkish account (2026-10-11). */
export function profileLocale(saved: string | null | undefined, ui: Locale): Locale {
  return saved === 'tr' || saved === 'en' ? saved : ui
}
